import {
  IDatabasePropertyResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IDatabasePropertyResponseInstance'
import {PropertyValueType} from '@toolify/server/src/services/DatabasePropertyService/types/PropertyValueType'

// The scale generates its ticks in raw minutes, so left alone a tracked-time axis lands them on
// arbitrary values — this tick math puts them on whole minutes or whole hours, whichever the range
// calls for. The matching H:MM tick formatter lives on the TimeTracker value-type strategy.

// Nice steps a duration axis can count in: minutes up to an hour, then whole hours, then days.
const niceStepsInMinutes = [1, 2, 5, 10, 15, 30, 60, 120, 180, 240, 360, 480, 720, 1440, 2880, 5760, 10080]
const maxTickCount = 7

interface ILinearAxis {
  min: number
  max: number
  ticks: Array<{value: number}>
}

export function isTimeTrackerValueAxis(rowDatabaseProperties: IDatabasePropertyResponseInstance[]): boolean {
  return !!rowDatabaseProperties?.length && rowDatabaseProperties.every(property => {
    return property?.valueType === PropertyValueType.TimeTracker
  })
}

export function getTimeTrackerTickStepInMinutes(maxValue: number): number | null {
  if(!Number.isFinite(maxValue) || maxValue <= 0) {
    return null
  }
  const fittingStep = niceStepsInMinutes.find(step => maxValue / step <= maxTickCount - 1)
  if(fittingStep) {
    return fittingStep
  }
  const largestStep = niceStepsInMinutes[niceStepsInMinutes.length - 1]
  return largestStep * Math.ceil(maxValue / (largestStep * (maxTickCount - 1)))
}

// Chart.js afterBuildTicks hook — replaces the generated ticks so the grid lands on round durations.
export function buildTimeTrackerValueAxisTicks(axis: ILinearAxis): void {
  const step = getTimeTrackerTickStepInMinutes(axis.max)
  if(!step) {
    return
  }
  const firstValue = Math.ceil(Math.max(axis.min, 0) / step) * step
  const ticks: Array<{value: number}> = []
  for(let value = firstValue; value <= axis.max; value += step) {
    ticks.push({value})
  }
  if(ticks.length) {
    axis.ticks = ticks
  }
}
